<template>
  <div class="wrapper">
    <div class="contentBox">
      <div class="header">
        <span class="level-left">
          <span class="level-tree" @click="goTo('review-list')"
            >返回上一级</span
          >
          <span class="text"> / 批卷</span>
        </span>

        <span class="gradeInfo">
          <span class="text">已批</span>：{{ markCount }} &nbsp;<span
            class="text"
            >|</span
          >
          &nbsp;<span class="text">未批</span>：{{ noMarkCount }}
        </span>
      </div>
      <div class="content">
        <div class="col-md-12 text-center">
          <h1>{{ examName }}</h1>
          <p style="margin: 20px 0">
            <span>用时(分)：{{ consumeTime }}</span>
            <span> | </span>
            <span>开始于: {{ startTime }}</span>
            <span> | </span>
            <span>完成：{{ endTime }}</span>
          </p>
        </div>

        <el-container>
          <div class="question box-card" shadow="always">
            <div
              class="item-question"
              v-for="(item, index) in questionList"
              :key="'question' + item.id"
            >
              <div class="ques-title">
                <span class="ques-type ques-qa"> {{ item.type }}</span>

                <span> {{ index + 1 }}. </span>
                <span style="display: inline-block">{{ item.content }}</span>
                <span class="ques-score" style="display: inline-block"
                  >({{ item.score }}分)</span
                >
              </div>

              <div class="referAnswer">
                <div class="grade-left">参考答案：</div>
                <div class="grade-right">
                  <span v-html="item.consultAnswer"></span>
                </div>
              </div>
              <div class="eassy_grading_answer">
                <div class="grading-user-answer grade-left">考生答案：</div>

                <div class="user-answer grade-right">
                  <!-- <pre> <input disabled="true" v-model="item.studentChooseList[0]" width="100%"></pre> -->
                  <pre><span id="answerTextTe1">{{item.studentChooseList[0]}}</span></pre>
                </div>
                <div class="answerTextNum">
                  字符数:
                  <span id="answerTextNum2">{{
                    item.studentChooseList[0] &&
                    item.studentChooseList[0].length
                  }}</span>
                </div>
                <div style="clear: both"></div>
              </div>

              <div class="commentContainer">
                <div class="commentTip">批注:</div>
                <textarea
                  v-model="item.comment"
                  autocomplete="off"
                  class="comment"
                ></textarea>
              </div>
              <div class="grade-score" data-isgrade="0">
                <img
                  title="未批"
                  class="result-img"
                  src="@/assets/question.png"
                />
                <label class="get-score">分数:&emsp;</label>
                <input
                  class="form-control getscore input"
                  v-model="item.giveScore"
                  type="number"
                  data-score="1"
                  :max="score"
                  min="0"
                  oninput="if(value>max)value=max;if(value.length>max.length)value=value.slice(0,max.length)"
                />
              </div>

              <div style="clear: both"></div>
            </div>
          </div>

          <div class="rightcolumn results">
            <p>批卷结果</p>
            <ul class="results-summary">
              <li>
                <span class="title">试卷总分: </span>
                <span class="result total-scores">{{ totalGetScore }}</span>
              </li>
              <li>
                <span class="title">非问答题分数: </span>
                <span class="result scores">0</span>
              </li>
              <li>
                <span class="title">问答题分数: </span>
                <span class="result grade-result">{{ totalSumAll }}</span>
              </li>
              <li>
                <span class="title">总得分: </span>
                <span class="result total-result">{{ totalSumAll }}</span>
              </li>
            </ul>
            <ul class="tips">
              <li>
                <div class="color right"></div>
                对
              </li>
              <li>
                <div class="color wrong"></div>
                错
              </li>
              <li>
                <div class="color undo"></div>
                未批
              </li>
            </ul>
            <ul class="result-status">
              <div
                class="form-validate"
                v-for="(item, index) in questionList"
                :key="'question' + item.id"
              >
                <li
                  :class="[
                    'form-validate',
                    item.giveScore === null || item.giveScore == ''
                      ? ''
                      : item.giveScore > 0
                      ? 'blueBg'
                      : 'redBg',
                  ]"
                >
                  {{ index + 1 }}
                </li>
              </div>
            </ul>
            <div class="form-actions">
              <div class="send-email" style="margin-bottom: 10px">
                <div class="cb" style="display: inline-block">
                  <input
                    id="sendEmail"
                    type="checkbox"
                    value="1"
                    name="sendemail"
                  />
                  <label for="sendEmail">将成绩发送到考生邮箱：</label>
                </div>
                <input
                  style="width: 260px"
                  class="input"
                  type="email"
                  placeholder="请输入邮箱"
                  name="email"
                  value=""
                />
              </div>
              <el-button
                type="primary"
                :disabled="ifCompeleteGiveScore"
                @click="toNextMarkExam"
                >批下一份卷</el-button
              >
              <!--   -->
              <el-button
                type="primary"
                :disabled="ifCompeleteGiveScore"
                @click="toMarkExam"
                >完成批卷</el-button
              >
            </div>
          </div>
        </el-container>
      </div>
    </div>
  </div>
</template>

<script>
import {
  examQueryMarkExam,
  toMarkExam,
  nextExamQueryMarkExam,
} from "@/api/examination/examination.js";
export default {
  data() {
    return {
      src: require("@/assets/question.png"),
      form: "111",
      payload: {
        content: "",
      },
      textarea: "",
      searchCondition: {
        recordId: "",
      },
      questionList: [],
      examName: "",
      startTime: "",
      endTime: "",
      consumeTime: "",
      totalGetScore: 0,
      markCount: "",
      noMarkCount: "",
      currentRecordId: "",
      score: 0,
    };
  },

  computed: {
    totalSumAll() {
      let totalSumAll = 0;
      this.questionList.forEach((item) => {
        if (!isNaN(item.giveScore)) totalSumAll -= -item.giveScore;
      });
      if (isNaN(totalSumAll)) {
        return 0;
      }
      return totalSumAll;
    },
    ifCompeleteGiveScore() {
      console.log(this.questionList);
      return this.questionList.some(
        (item) => item.giveScore == null || item.giveScore == ""
      );
    },
  },
  created() {},
  mounted() {
    let item = this.$route.query;
    this.getExamRecord();
  },
  methods: {
    getExamRecord() {
      let params = {
        recordId: this.$route.query.id,
      };
      examQueryMarkExam(params).then((data) => {
        data.questionInfoDTOList.forEach((item) => {
          item.giveScore = null;
        });
        this.data = data;

        this.examName = data.examName;
        this.startTime = data.startTime;
        this.endTime = data.endTime;
        this.consumeTime = data.consumeTime;
        this.totalGetScore = data.totalGetScore;
        this.markCount = data.markCount;
        this.noMarkCount = data.noMarkCount;
        this.currentRecordId = data.recordId;
        this.score = data.score;
        for (let i = 0; i < data.questionInfoDTOList.length; i++) {
          var reg = /<\/?.+?\/?>/g;
          data.questionInfoDTOList[i].content = data.questionInfoDTOList[
            i
          ].content.replace(reg, "");
        }
        this.questionList = data.questionInfoDTOList;
      });
    },
    getNextExamRecord() {
      let params = {
        recordId: this.currentRecordId,
      };
      nextExamQueryMarkExam(params).then((data) => {
        data.questionInfoDTOList.forEach((item) => {
          item.giveScore = null;
        });
        this.data = data;
        this.questionList = data.questionInfoDTOList;
        this.examName = data.examName;
        this.startTime = data.startTime;
        this.endTime = data.endTime;
        this.consumeTime = data.consumeTime;
        this.totalGetScore = data.totalGetScore;
        this.markCount = data.markCount;
        this.noMarkCount = data.noMarkCount;
        this.currentRecordId = data.recordId;
      });
    },

    toMarkExam() {
      let params = {
        recordId: this.$route.query.id,
        dtoList: this.questionList,
        score: this.totalSumAll,
      };
      toMarkExam(params).then((data) => {
        console.log("hhhh", data);
        this.$router.go(-1);
        // this.$router.push({ name: "recordList" });
      });
    },
    toNextMarkExam() {
      console.log("currentRecordId", this.currentRecordId);
      let params = {
        recordId: this.currentRecordId,
        dtoList: this.questionList,
        score: this.totalSumAll,
      };
      toMarkExam(params).then((data) => {
        console.log("请求结果", data);

        this.getNextExamRecord();
        console.log("成功了 新的id", this.currentRecordId);
      });
    },

    goTo(url) {
      this.$router.push({ name: url, id: this.$route.query.id });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .question-item {
    padding: 10px;
    border-left: solid 1px #e6e6e6;
    border-right: solid 1px #e6e6e6;
  }
  .score {
    margin-left: 15%;
    font-size: 16px;
  }

  .rightcolumn {
    overflow: auto;
    width: 20%;
    position: fixed;
    max-height: 622px;
    margin-bottom: 30px;
    left: 77%;
    padding-right: 30px;
    padding-left: 15px;
  }

  .questions-details {
    padding: 10px;
    margin-top: 20px;
  }

  p.user-answer {
    padding: 10px;
    border: solid 1px #e5e5e5;
  }

  .questions-details .question {
    margin-top: 40px;
    padding: 10px;
  }

  .question-number,
  .question-content {
    display: inline-block;
  }
  .question-number {
    width: 20%;
    float: left;
  }

  .question-content {
    margin-left: 20px;
  }

  .referAnswer {
    margin-bottom: 10px;
    color: #666;
    font-size: 14px;
  }

  // .eassy_grading_answer {
  //   margin-top: 20px;
  // }
  .question.right .question-content {
    border-left: 4px solid #3a9c95;
    padding-left: 10px;
  }
  .question.wrong .question-content {
    border-left: 4px solid #f3565d;
    padding-left: 10px;
  }
  .form-actions {
    margin-top: 40px;
  }
  input.getscore {
    width: 16%;
    display: inline-block;
  }
  .score-label {
    cursor: pointer;
    padding: 5px 8px 5px 8px;
  }

  .score-label:hover {
    background-color: #1d7580;
  }
  /*.question.result.right .question-grading .btn, .question.result.wrong .question-grading .btn{
        opacity: 0.6
    }*/
  .essayAsImg,
  .essayAsAudio {
    overflow: hidden;
    margin-bottom: 15px;
  }
  .essayAsImg a.img-show {
    display: block;
    max-width: 30%;
    float: left;
    margin: 0 10px 10px 0;
    padding: 5px;
  }
  .essayAsImg a.img-show img {
    width: 100%;
    margin: 0;
    box-shadow: 0px 4px 15px 0px rgba(190, 190, 190, 0.35);
  }
  .audio-cell {
    margin-bottom: 10px;
  }
  .pp_social {
    display: none !important;
  }
  pre {
    white-space: pre-wrap; /* css3.0 */
    white-space: -moz-pre-wrap; /* Firefox */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
    display: block;
    padding: 9.5px;
    margin: 0 0 10px;
    font-size: 13px;
    line-height: 1.42857143;
    color: #333;
    word-break: break-all;
    word-wrap: break-word;
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  .file-cell {
    margin-bottom: 20px;
  }
  .file-cell .default {
    width: 80%;
    text-align: left;
    margin-right: 10px;
  }
  .file-cell a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .grade-left {
    color: #999;
    /*float: left;*/
    width: 100%;
    padding-top: 10px;
  }
  .grade-right {
    /*float: left;*/
    margin: 10px 0 0 0;
    width: 100%;
  }

  .grade-right > pre {
    height: auto;
    padding: 10px 20px;
    font-size: 15px;
  }
  .question {
    padding: 0 !important;
    .ques-title {
      border-top: 1px #e6e6e6;
      font-size: 14px;
      .ques-type {
        border: 1px solid;
        border-radius: 2px !important;
        padding: 2px;
        vertical-align: middle;
      }
      .ques-qa {
        color: #bf7dcd;
        border-color: #bf7dcd;
      }
    }
  }
  // .ques-title,
  // .referAnswer,
  // .eassy_grading_answer {
  //   margin: 0 !important;
  //   padding: 8px 10px 10px;
  //   border-left: 1px #e6e6e6;
  //   border-right: 1px #e6e6e6;
  // }

  .eassy_grading_answer {
    border-bottom: 1px #e6e6e6;
  }
  .grade-score {
    padding: 20px 10px 20px 84px;
  }
  .question-grading,
  .grade-score {
    .get-score {
      font-size: 16px;
      color: #333;
    }
    img {
      width: 16px;
      margin-right: 20px;
    }
  }
  .grade-score .score-label {
    background-color: #82cbff;
    border-radius: 4px !important;
    padding: 9px 14px;
    font-size: 14px;
    cursor: pointer;
    margin-right: 5px;
  }
  .score-label.active {
    background-color: #36aafd;
  }
  .questions-details .question {
    margin: 0 0 30px 0;
    padding: 10px;
  }
  .results {
    max-width: 25%;
    margin-top: 20px;
    text-align: center !important;
    background-color: #ffffff;
    box-shadow: 0px 4px 15px 0px rgba(190, 190, 190, 0.35);
    border-radius: 4px !important;
    border: 0 !important;
    padding: 10px;
  }
  .results p {
    font-size: 20px;
    color: #222222;
    margin-bottom: 20px;
  }
  .results ul {
    padding: 0;
    list-style: none;
    text-align: left !important;
    margin: 0;
    display: flex;
  }
  .result-status li {
    display: inline-block;
    width: 30px;
    height: 30px;
    margin: 10px 10px 0 0;
    border-radius: 4px !important;
    text-align: center !important;
    background: #d9d9d9;
    color: #fff;
    font-size: 14px;
    line-height: 30px;
    cursor: pointer;
  }
  .results .tips {
    width: 100%;
    height: 30px;
    padding: 0px;
    margin-top: 10px;
    list-style: none;
  }
  .tips li {
    display: inline-block;
    float: left;
    width: 24%;
    margin-left: 6%;
    cursor: pointer;
  }
  .tips .color {
    width: 10px;
    height: 10px;
    margin-right: 4px;
    border-radius: 1px;
    display: inline-block;
  }
  .results .right {
    background-color: #36aafd;
  }
  .results .wrong {
    background-color: #ff5353;
  }
  .results .undo {
    background-color: #d9d9d9;
  }
  .results-summary {
    list-style: none;
    padding: 0 0 20px 0;
    border-bottom: 1px solid #e6e6e6;
    text-align: left;
    font-size: 14px;
    clear: both;
    display: block !important;
  }
  .results-summary li {
    padding: 0 0 10px 0 !important;
  }
  .results-summary .title {
    display: inline-block;
    min-width: 100px;
    margin-right: 5px;
    color: #999;
  }
  .details .title {
    display: inline-block;
    float: left;
    min-width: 100px;
    margin-right: 5px;
    color: #999;
  }
  // .page-content {
  //   padding: 0 !important;
  //   background: #f3f4f8;
  //   position: relative;
  // }
  .contentBox {
    background: #fff;
    .right {
      text-align: center;
    }
    .header {
      height: 48px;
      color: rgba(51, 51, 51, 1);
      font-size: 16px;
      line-height: 48px;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      .level-left {
        color: #999;
        font-size: 14px;
        .level-tree:hover {
          color: #36aafd;
          cursor: pointer;
        }
        .text {
          color: #333333;
        }
      }
    }
  }

  .contentBox .qcotent img {
    max-width: 30%;
    box-shadow: 0px 4px 15px 0px rgba(190, 190, 190, 0.35);
    padding: 5px;
  }
  .grade-right img {
    max-width: 30%;
    box-shadow: 0px 4px 15px 0px rgba(190, 190, 190, 0.35);
    padding: 5px;
  }
  .form-actions {
    margin-top: 20px;
    text-align: left;
  }
  .form-actions .input {
    width: 100% !important;
    margin: 10px 0;
  }

  .commentContainer {
    padding: 20px 0px 0px 126px;
    border-top: solid 1px #e6e6e6;
  }

  .commentTip {
    font-size: 16px;
    color: #333;
    display: inline-block;
    top: -33px;
    margin-right: 2px;
  }

  .comment {
    height: 74px;
    width: 90%;
    border-radius: 4px !important;
    border: 1px solid #e2e2e2;
    padding: 10px 20px;
    transition: all 0.5s ease;
    height: 85px;
  }

  .comment:hover {
    border-color: #999;
  }

  .comment:focus {
    border-color: #999;
  }

  .gradeInfo {
    float: right;
    font-size: 14px;
    margin-right: 40px;
  }
  .gradeInfo > .text {
    color: #999 !important;
  }
  .answerTextNum {
    float: right;
    margin: 5px 5px 0 0;
  }

  .col-md-12 {
    text-align: center;
  }

  .row {
    background: #fff;
    border: solid 1px #e5e5e5;
  }

  .el-container {
    margin-bottom: 40px;
  }
  .el-aside {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  }
}
.blueBg {
  background: #409eff !important;
}
.redBg {
  background: #ff5353 !important;
}
.item-question {
  position: relative;
  padding-left: 10px;
  margin-bottom: 30px 30px 30px 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 10px 10px 10px 10px;
  width: 75%;
  margin: 20px 20px 20px 20px;
}

// .col-xs-12 {
//   width: 100%;
//   position: relative;
//   min-height: 1px;
//   padding-right: 15px;
//   padding-left: 15px;
//   float: left;
// }
h1 {
  font-size: 33px;
  font-family: inherit;
  line-height: 1.1;
  color: inherit;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-weight: 400;
}
.box-card {
  width: 95%;
  height: auto;
}
.textarea {
  overflow: auto;
}
</style>
